import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { Translate, withLocalize } from 'react-localize-redux';
import Icon, { IconSizes, IconVariants } from '../../components/foundations/Icon';
import TopbarService from '../../services/topbar';
import { getUserData } from '../../selectors/user';
import toaster from '../../utils/toaster';
import { trackMixpanelEvent } from '../../utils/general';
import { buildLogsDownloadUrl } from '../../utils/url';
import { shouldShowAuditButton } from '../utils';
import { HEADERS } from '../consts';
import css from '../style.css';

const topbarService = new TopbarService();

const buildAuditUrl = validationId =>
    buildLogsDownloadUrl(`validation_id=${validationId}&validation_type=general`);

function AuditReportButton({ translate }) {
    const userData = useSelector(getUserData) || {};
    const [running, setRunning] = useState(false);

    if (!userData.email || !shouldShowAuditButton(userData)) {
        return null;
    }

    const onClick = () => {
        if (running) return;
        setRunning(true);
        topbarService
            .runGeneralAudit()
            .then(({ validationId }) => {
                trackMixpanelEvent('Audits', 'Clicked GENERAL Audit', { validationId });
                window.open(buildAuditUrl(validationId), '_blank');
            })
            .catch(() => toaster.error(translate(`${HEADERS}.AUDIT_ERROR`)))
            .finally(() => setRunning(false));
    };

    return (
        <button type="button" className={css.menuToggle} onClick={onClick} disabled={running}>
            <Icon name="activity" size={IconSizes.MEDIUM} variant={IconVariants.WHITE} />
            <Translate id={`${HEADERS}.AUDIT`} />
        </button>
    );
}

AuditReportButton.propTypes = {
    translate: PropTypes.func.isRequired,
};

export default withLocalize(AuditReportButton);
